module.exports = __webpack_public_path__ + "img/issue_1.d33b588d.png";